import React from 'react';
import {
  Dashboard as DashboardIcon,
  ForwardToInbox as AccountsNotifyIcon,
  AddBox,
  Inbox as InboxIcon,
  HourglassEmpty,
  CheckCircle,
  AccountBalance,
  Assessment,
  Schedule as ScheduleIcon,
  People,
  Business,
  Settings as SettingsIcon,
  GroupWork as GroupWorkIcon,
  Security as SecurityIcon,
  AccountTree as AccountTreeIcon,
  Computer as ComputerIcon,
  ShoppingBasket,
  Gavel,
  Draw as DrawIcon,
  RequestQuote as PaymentRequestIcon,
  ReceiptLong as AutoInvoiceIcon,
  Storefront as StorefrontIcon,
  Inventory2 as InventoryIcon,
  AddShoppingCart as AddShoppingCartIcon,
  ListAlt as ListAltIcon,
  AccountBalanceWallet as SoaIcon,
  DesignServices as SoaTemplateIcon,
  Description as FormattedSoaIcon,
  FactCheck as FactCheckIcon,
  PlaylistAddCheck as PickListIcon,
  Summarize as SummarizeIcon,
  Tune as TuneIcon,
  QrCodeScanner as ScanIcon,
  QrCode2 as BarcodeIcon,
  Warehouse as WarehouseIcon,
  Spellcheck as ItemSeedIcon,
  Summarize as McsrReportIcon,
  Insights as McsrDashboardIcon,
  CloudSync as McsrSyncIcon,
  MoveToInbox as GrpoIcon,
  LocalPrintshop as InvoicePrintIcon,
  Approval as SapApprovalIcon,
  AddCircleOutline as NewItemIcon,
  Assignment as ItemRequestsIcon,
  EventRepeat as RuleYearCopyIcon,
  EventNote as ProjectReportsIcon,
  ReportProblem as ProjectIssuesIcon,
  Payments as PettyCashIcon,
  PostAdd as NewClaimIcon,
  Store as SuppliersIcon,
  SettingsSuggest as PettyCashSetupIcon,
  ContactMail as EnquiryIcon,
  RequestPage as InvoiceRequestIcon,
  TableChart as QuotationRegisterIcon,
  ManageSearch as PrInquiryIcon,
  FindInPage as PoInquiryIcon,
  SettingsApplications as E2ISetupIcon,
} from '@mui/icons-material';

// Import page components
import Dashboard from '../pages/Dashboard';
import PRDashboard from '../pages/PRDashboard';
import CreatePR from '../pages/CreatePR';
import CreatePO from '../pages/CreatePO';
import POTracker from '../pages/POTracker';
import GoodsReceiptPO from '../pages/GoodsReceiptPO';
import Inbox from '../pages/Inbox';
import InProgress from '../pages/InProgress';
import Completed from '../pages/Completed';
import Budget from '../pages/Budget';
import Reports from '../pages/Reports';
import PRDetailReport from '../pages/PRDetailReport';
import PRInquiry from '../pages/PRInquiry';
import POInquiry from '../pages/POInquiry';
import ScheduleJobs from '../pages/ScheduleJobs';
import UserManagement from '../pages/UserManagement';
import CompanyManagement from '../pages/CompanyManagement';
import GeneralSettings from '../pages/GeneralSettings';
import ApprovalFlowSettings from '../pages/ApprovalFlowSettings';
import BulkWorkflowManagement from '../pages/BulkWorkflowManagement';
import Projects from '../pages/Projects';
import RoleManagement from '../pages/RoleManagement';
import CostCenterMapping from '../pages/CostCenterMapping';
import TransactionSync from '../pages/TransactionSync';
import SystemMonitor from '../pages/SystemMonitor';
import CreateSubcontract from '../pages/CreateSubcontract';
import SubcontractDocuments from '../pages/SubcontractDocuments';
import PaymentCertificate from '../pages/PaymentCertificate';
import SubcontractVariation from '../pages/SubcontractVariation';
import SubcontractWorkDone from '../pages/SubcontractWorkDone';
import DocuSignSigning from '../pages/DocuSignSigning';
import PaymentRequestList from '../pages/PaymentRequestList';
import PaymentRequestCreate from '../pages/PaymentRequestCreate';
import PaymentRequestDetail from '../pages/PaymentRequestDetail';
import PaymentRequestWorkflow from '../pages/PaymentRequestWorkflow';
import AutoInvoice from '../pages/AutoInvoice';
import SalesStock from '../pages/SalesStock';
import SalesOrderCreate from '../pages/SalesOrderCreate';
import SalesOrderList from '../pages/SalesOrderList';
import CustomerSOA from '../pages/CustomerSOA';
import FormattedSOA from '../pages/FormattedSOA';
import SoaTemplates from '../pages/SoaTemplates';
import SalesApprovalQueue from '../pages/SalesApprovalQueue';
import SalesOrderReport from '../pages/SalesOrderReport';
import SalesInvoicePrint from '../pages/SalesInvoicePrint';
import SalesOrderPrint from '../pages/SalesOrderPrint';
import SalesPortalSettings from '../pages/SalesPortalSettings';
import WarehouseReceiving from '../pages/WarehouseReceiving';
import WarehouseItemSeed from '../pages/WarehouseItemSeed';
import WarehouseBarcode from '../pages/WarehouseBarcode';
import WarehousePickingList from '../pages/WarehousePickingList';
import McsrReport from '../pages/McsrReport';
import McsrDashboard from '../pages/McsrDashboard';
import McsrSyncMonitor from '../pages/McsrSyncMonitor';
import SapApprovalWorkflows from '../pages/SapApprovalWorkflows';
import AccountsNotifications from '../pages/AccountsNotifications';
import ItemRequestForm from '../pages/ItemRequestForm';
import ItemRequestList from '../pages/ItemRequestList';
import ItemRequestDetail from '../pages/ItemRequestDetail';
import GLRuleYearCopy from '../pages/GLRuleYearCopy';
import ProjectReports from '../pages/ProjectReports';
import ProjectReportEditor from '../pages/ProjectReportEditor';
import ProjectIssues from '../pages/ProjectIssues';
import PettyCashClaims from '../pages/PettyCashClaims';
import PettyCashClaim from '../pages/PettyCashClaim';
import PettyCashSetup from '../pages/PettyCashSetup';
import Suppliers from '../pages/Suppliers';
import E2IEnquiries from '../pages/E2IEnquiries';
import E2IEnquiry from '../pages/E2IEnquiry';
import E2IInvoiceRequests from '../pages/E2IInvoiceRequests';
import E2IRegister from '../pages/E2IRegister';
import E2ISetup from '../pages/E2ISetup';

export interface ModuleItem {
  key: string;
  path: string;
  label: string;
  icon?: React.ReactNode;
  component: React.ComponentType;
  moduleKey: string;
  order: number;
  roles?: string[];
  hideFromMenu?: boolean;
}

export const MODULES: ModuleItem[] = [
  {
    key: 'dashboard',
    path: '/dashboard',
    label: 'Main Dashboard',
    icon: <DashboardIcon />,
    component: Dashboard,
    moduleKey: 'dashboard',
    order: 10,
  },
  {
    key: 'pr-dashboard',
    path: '/pr-dashboard',
    label: 'PR Dashboard',
    icon: <DashboardIcon />,
    component: PRDashboard,
    moduleKey: 'pr-dashboard',
    order: 11,
  },
  {
    key: 'create-pr',
    path: '/create-pr',
    label: 'Create PR',
    icon: <AddBox />,
    component: CreatePR,
    moduleKey: 'create-pr',
    order: 20,
  },
  {
    key: 'pr-inquiry',
    path: '/pr-inquiry',
    label: 'PR Inquiry',
    icon: <PrInquiryIcon />,
    component: PRInquiry,
    moduleKey: 'pr-inquiry',
    // Right under Create PR (20).
    order: 20.5,
  },
  {
    key: 'create-po',
    path: '/create-po',
    label: 'Create PO',
    icon: <ShoppingBasket />,
    component: CreatePO,
    moduleKey: 'create-po',
    order: 25,
  },
  {
    key: 'po-tracker',
    path: '/po-tracker',
    label: 'PO Tracker',
    icon: <ShoppingBasket />,
    component: POTracker,
    moduleKey: 'create-po',
    order: 25.1,
    hideFromMenu: true,
  },
  {
    key: 'po-inquiry',
    path: '/po-inquiry',
    label: 'PO Inquiry',
    icon: <PoInquiryIcon />,
    component: POInquiry,
    moduleKey: 'po-inquiry',
    // Right under Create PO (25), before GRPO (25.3).
    order: 25.2,
  },
  {
    key: 'grpo',
    path: '/grpo',
    label: 'GRPO',
    icon: <GrpoIcon />,
    component: GoodsReceiptPO,
    moduleKey: 'grpo',
    // Between Create PO (25) and Payment Requests (25.5).
    order: 25.3,
  },
  {
    key: 'payment-requests',
    path: '/payment-requests',
    label: 'Payment Requests',
    icon: <PaymentRequestIcon />,
    component: PaymentRequestList,
    moduleKey: 'create-payment-request',
    order: 25.5,
  },
  {
    key: 'auto-invoice',
    path: '/auto-invoice',
    label: 'Auto Invoice',
    icon: <AutoInvoiceIcon />,
    component: AutoInvoice,
    moduleKey: 'auto-invoice',
    order: 25.7,
  },
  {
    key: 'sales-stock',
    path: '/sales/stock',
    label: 'Live Stock Check',
    icon: <InventoryIcon />,
    component: SalesStock,
    moduleKey: 'sales-stock',
    roles: ['Salesperson', 'SalesManagement', 'FinanceManager', 'Admin'],
    order: 30,
  },
  {
    key: 'sales-order-create',
    path: '/sales/orders/new',
    label: 'Create Sales Order',
    icon: <AddShoppingCartIcon />,
    component: SalesOrderCreate,
    moduleKey: 'sales-order-create',
    roles: ['Salesperson', 'SalesManagement', 'Admin'],
    order: 31,
  },
  {
    key: 'sales-orders',
    path: '/sales/orders',
    label: 'My Sales Orders',
    icon: <ListAltIcon />,
    component: SalesOrderList,
    moduleKey: 'sales-orders',
    roles: ['Salesperson', 'SalesManagement', 'Admin'],
    order: 32,
  },
  {
    key: 'sales-order-edit',
    path: '/sales/orders/:id/edit',
    label: 'Edit Sales Order',
    icon: <AddShoppingCartIcon />,
    component: SalesOrderCreate,
    moduleKey: 'sales-order-create',
    roles: ['Salesperson', 'SalesManagement', 'Admin'],
    order: 31.1,
    hideFromMenu: true,
  },
  {
    key: 'sales-soa',
    path: '/sales/soa',
    label: 'Customer SOA',
    icon: <SoaIcon />,
    component: CustomerSOA,
    moduleKey: 'sales-soa',
    roles: ['Salesperson', 'SalesManagement', 'FinanceManager', 'Admin'],
    order: 33,
  },
  {
    // Statements laid out by the company's templates (docs/FORMATTED_SOA.md); Admin by default,
    // anyone else through the module in User Management.
    key: 'formatted-soa',
    path: '/sales/formatted-soa',
    label: 'Formatted SOA',
    icon: <FormattedSoaIcon />,
    component: FormattedSOA,
    moduleKey: 'formatted-soa',
    roles: ['Admin'],
    order: 33.1,
  },
  {
    key: 'formatted-soa-templates',
    path: '/sales/formatted-soa/templates',
    label: 'Statement Templates',
    icon: <SoaTemplateIcon />,
    component: SoaTemplates,
    moduleKey: 'formatted-soa-designer',
    roles: ['Admin'],
    order: 33.2,
  },
  {
    key: 'formatted-soa-template-edit',
    path: '/sales/formatted-soa/templates/:id',
    label: 'Statement Template',
    icon: <SoaTemplateIcon />,
    component: SoaTemplates,
    moduleKey: 'formatted-soa-designer',
    roles: ['Admin'],
    order: 33.3,
    hideFromMenu: true,
  },
  {
    key: 'sales-approvals',
    path: '/sales/approvals',
    label: 'Sales Order Approvals',
    icon: <FactCheckIcon />,
    component: SalesApprovalQueue,
    moduleKey: 'sales-approvals',
    roles: ['SalesManagement', 'Admin'],
    order: 34,
  },
  {
    key: 'sales-order-report',
    path: '/sales/reports/orders',
    label: 'Sales Order Report',
    icon: <SummarizeIcon />,
    component: SalesOrderReport,
    moduleKey: 'sales-order-report',
    // Reads every salesperson's orders, so it matches sales.order.view_all on
    // the route — not the Salesperson role, which is scoped to its own orders.
    roles: ['SalesManagement', 'FinanceManager', 'Admin'],
    order: 34.5,
  },
  {
    key: 'sales-invoice-print',
    path: '/sales/invoices/print',
    label: 'Print A/R Invoices',
    icon: <InvoicePrintIcon />,
    component: SalesInvoicePrint,
    moduleKey: 'sales-invoice-print',
    roles: ['SalesManagement', 'FinanceManager', 'Admin'],
    order: 34.7,
  },
  {
    // Separate from invoice printing (different users print each): Admin by default, anyone else
    // through the module in User Management (e.g. the billing team's Viewer users).
    key: 'sales-order-print',
    path: '/sales/order-print',
    label: 'Print Sales Orders',
    icon: <InvoicePrintIcon />,
    component: SalesOrderPrint,
    moduleKey: 'sales-order-print',
    roles: ['Admin'],
    order: 34.75,
  },
  {
    key: 'sales-portal-settings',
    path: '/sales/settings',
    label: 'Sales Portal Settings',
    icon: <TuneIcon />,
    component: SalesPortalSettings,
    moduleKey: 'sales-portal-settings',
    roles: ['Admin', 'FinanceManager', 'SalesManagement'],
    order: 35,
  },
  {
    key: 'payment-request-create',
    path: '/payment-requests/new',
    label: 'New Payment Request',
    icon: <PaymentRequestIcon />,
    component: PaymentRequestCreate,
    moduleKey: 'create-payment-request',
    order: 25.51,
    hideFromMenu: true,
  },
  {
    key: 'payment-request-edit',
    path: '/payment-requests/:id/edit',
    label: 'Edit Payment Request',
    icon: <PaymentRequestIcon />,
    component: PaymentRequestCreate,
    moduleKey: 'create-payment-request',
    order: 25.52,
    hideFromMenu: true,
  },
  {
    key: 'payment-request-detail',
    path: '/payment-requests/:id',
    label: 'Payment Request',
    icon: <PaymentRequestIcon />,
    component: PaymentRequestDetail,
    moduleKey: 'create-payment-request',
    order: 25.53,
    hideFromMenu: true,
  },
  {
    key: 'create-subcontract',
    path: '/subcontract/create',
    label: 'Create Subcontract',
    icon: <Gavel />,
    component: CreateSubcontract,
    moduleKey: 'create-subcontract',
    order: 26,
  },
  {
    key: 'subcontract-documents',
    path: '/subcontract/documents',
    label: 'Subcontract Documents',
    icon: <Gavel />,
    component: SubcontractDocuments,
    moduleKey: 'subcontract-documents',
    order: 27,
  },
  {
    key: 'payment-certificate',
    path: '/subcontract/payment-certificate',
    label: 'Payment Certificate',
    icon: <Gavel />,
    component: PaymentCertificate,
    moduleKey: 'payment-certificate',
    order: 28,
  },
  {
    key: 'subcontract-variation',
    path: '/subcontract/variation',
    label: 'Subcontract Variation',
    icon: <Gavel />,
    component: SubcontractVariation,
    moduleKey: 'subcontract-variation',
    order: 28.5,
  },
  {
    key: 'subcontract-work-done',
    path: '/subcontract/work-done',
    label: 'Subcontract Work Done',
    icon: <Gavel />,
    component: SubcontractWorkDone,
    moduleKey: 'subcontract-work-done',
    order: 28.6,
  },
  {
    key: 'docusign-signing',
    path: '/docusign/signing',
    label: 'DocuSign Signing',
    icon: <DrawIcon />,
    component: DocuSignSigning,
    moduleKey: 'docusign-signing',
    order: 29,
  },
  {
    key: 'inbox',
    path: '/inbox',
    label: 'Inbox',
    icon: <InboxIcon />,
    component: Inbox,
    moduleKey: 'inbox',
    order: 30,
  },
  {
    key: 'in-progress',
    path: '/in-progress',
    label: 'In Progress',
    icon: <HourglassEmpty />,
    component: InProgress,
    moduleKey: 'in-progress',
    order: 40,
  },
  {
    key: 'completed',
    path: '/completed',
    label: 'Completed',
    icon: <CheckCircle />,
    component: Completed,
    moduleKey: 'completed',
    order: 50,
  },
  {
    key: 'budget',
    path: '/budget',
    label: 'Budget',
    icon: <AccountBalance />,
    component: Budget,
    moduleKey: 'budget',
    order: 60,
  },
  {
    key: 'reports',
    path: '/reports',
    label: 'Reports',
    icon: <Assessment />,
    component: Reports,
    moduleKey: 'reports',
    order: 70,
  },
  {
    key: 'pr-detail-report',
    path: '/reports/pr-details',
    label: 'PR Detail Report',
    icon: <Assessment />,
    component: PRDetailReport,
    moduleKey: 'pr-detail-report',
    order: 71,
  },
  // Admin modules
  {
    key: 'schedule-jobs',
    path: '/schedule-jobs',
    label: 'Schedule Jobs',
    icon: <ScheduleIcon />,
    component: ScheduleJobs,
    roles: ['Admin', 'FinanceManager', 'GeneralManager'],
    moduleKey: 'schedule-jobs',
    order: 75,
  },
  {
    key: 'users',
    path: '/users',
    label: 'User Management',
    icon: <People />,
    component: UserManagement,
    roles: ['Admin', 'FinanceManager', 'GeneralManager'],
    moduleKey: 'users',
    order: 80,
  },
  {
    key: 'companies',
    path: '/companies',
    label: 'Company Management',
    icon: <Business />,
    component: CompanyManagement,
    roles: ['Admin', 'FinanceManager', 'GeneralManager'],
    moduleKey: 'companies',
    order: 90,
  },
  {
    key: 'general-settings',
    path: '/settings/general',
    label: 'General Settings',
    icon: <SettingsIcon />,
    component: GeneralSettings,
    moduleKey: 'general-settings',
    roles: ['Admin', 'FinanceManager', 'GeneralManager'],
    order: 89,
  },
  {
    key: 'approval-flow-settings',
    path: '/settings/approval-flow',
    label: 'Approval Flow',
    icon: <SettingsIcon />,
    component: ApprovalFlowSettings,
    moduleKey: 'approval-flow-settings',
    roles: ['Admin', 'GeneralManager'],
    order: 96,
  },
  {
    key: 'sap-approval-workflows',
    path: '/settings/sap-approval-workflows',
    label: 'SAP Approval Workflows',
    icon: <SapApprovalIcon />,
    component: SapApprovalWorkflows,
    moduleKey: 'sap-approval-workflows',
    roles: ['Admin'],
    order: 96.05,
  },
  {
    key: 'accounts-notifications',
    path: '/settings/accounts-notifications',
    label: 'Accounts notifications',
    icon: <AccountsNotifyIcon />,
    component: AccountsNotifications,
    moduleKey: 'accounts-notifications',
    roles: ['Admin'],
    order: 96.06,
  },
  {
    key: 'payment-request-workflow',
    path: '/admin/payment-request-workflow',
    label: 'Payment Request Workflow',
    icon: <PaymentRequestIcon />,
    component: PaymentRequestWorkflow,
    moduleKey: 'payment-request-workflow',
    // Restricted to Admin per spec H.15: this editor mutates DocuSign signing
    // groups in lockstep with workflow user assignments, which is a
    // higher-privilege operation than the generic GM-level workflow tweaks.
    roles: ['Admin'],
    order: 96.1,
  },
  {
    key: 'bulk-workflow-management',
    path: '/settings/bulk-workflow',
    label: 'Bulk Workflow Management',
    icon: <GroupWorkIcon />,
    component: BulkWorkflowManagement,
    moduleKey: 'bulk-workflow-management',
    roles: ['Admin', 'GeneralManager'],
    order: 96.5,
  },
  {
    key: 'projects',
    path: '/settings/projects',
    label: 'Project Management',
    icon: <Business />,
    component: Projects,
    moduleKey: 'projects',
    roles: ['Admin', 'FinanceManager', 'GeneralManager'],
    order: 97,
  },
  {
    key: 'role-management',
    path: '/settings/role-management',
    label: 'Role Management',
    icon: <SecurityIcon />,
    component: RoleManagement,
    moduleKey: 'role-management',
    roles: ['Admin'],
    order: 98,
  },
  {
    key: 'cost-center-mapping',
    path: '/settings/cost-center-mapping',
    label: 'Cost Center Mapping',
    icon: <AccountTreeIcon />,
    component: CostCenterMapping,
    moduleKey: 'cost-center-mapping',
    roles: ['Admin', 'FinanceManager', 'GeneralManager'],
    order: 99,
  },
  {
    key: 'transaction-sync',
    path: '/settings/transaction-sync',
    label: 'Transaction Sync',
    icon: <SettingsIcon />,
    component: TransactionSync,
    moduleKey: 'transaction-sync',
    roles: ['Admin', 'FinanceManager'],
    order: 100,
  },
  {
    key: 'system-monitor',
    path: '/settings/system-monitor',
    label: 'System Monitor',
    icon: <ComputerIcon />,
    component: SystemMonitor,
    moduleKey: 'system-monitor',
    roles: ['Admin'],
    order: 101,
  },
  {
    key: 'warehouse-receiving',
    path: '/warehouse/receiving',
    label: 'Warehouse Receiving',
    icon: <ScanIcon />,
    component: WarehouseReceiving,
    moduleKey: 'warehouse-receiving',
    roles: ['Warehouse', 'Admin'],
    order: 35,
  },
  {
    key: 'warehouse-item-seed',
    path: '/warehouse/item-seed',
    label: 'Item Seed',
    icon: <ItemSeedIcon />,
    component: WarehouseItemSeed,
    moduleKey: 'warehouse-item-seed',
    roles: ['Warehouse', 'Admin'],
    order: 36,
  },
  {
    key: 'warehouse-barcode',
    path: '/warehouse/barcode',
    label: 'Barcode',
    icon: <BarcodeIcon />,
    component: WarehouseBarcode,
    moduleKey: 'warehouse-barcode',
    roles: ['Warehouse', 'Admin'],
    order: 37,
  },
  {
    key: 'warehouse-picking-list',
    path: '/warehouse/picking-list',
    label: 'Picking List',
    icon: <PickListIcon />,
    component: WarehousePickingList,
    moduleKey: 'warehouse-picking-list',
    // Mirrors the route guard: warehouse does the picking, Sales Management
    // plans against it.
    roles: ['Warehouse', 'SalesManagement', 'Admin'],
    order: 37.5,
  },
  {
    key: 'item-request-create',
    path: '/warehouse/item-requests/new',
    label: 'Create New Item',
    icon: <NewItemIcon />,
    component: ItemRequestForm,
    moduleKey: 'item-requests',
    order: 37.6,
  },
  {
    key: 'item-requests',
    path: '/warehouse/item-requests',
    label: 'Item Requests',
    icon: <ItemRequestsIcon />,
    component: ItemRequestList,
    moduleKey: 'item-requests',
    order: 37.7,
  },
  {
    key: 'item-request-edit',
    path: '/warehouse/item-requests/:id/edit',
    label: 'Edit Item Request',
    icon: <ItemRequestsIcon />,
    component: ItemRequestForm,
    moduleKey: 'item-requests',
    order: 37.8,
    hideFromMenu: true,
  },
  {
    key: 'item-request-detail',
    path: '/warehouse/item-requests/:id',
    label: 'Item Request',
    icon: <ItemRequestsIcon />,
    component: ItemRequestDetail,
    moduleKey: 'item-requests',
    order: 37.9,
    hideFromMenu: true,
  },
  {
    key: 'gl-rule-year-copy',
    path: '/settings/gl-rule-year-copy',
    label: 'G/L Rules Year Copy',
    icon: <RuleYearCopyIcon />,
    component: GLRuleYearCopy,
    moduleKey: 'gl-rule-year-copy',
    roles: ['Admin'],
    order: 101.5,
  },
  {
    key: 'mcsr-report',
    path: '/mcsr/report',
    label: 'MCSR Report',
    icon: <McsrReportIcon />,
    component: McsrReport,
    moduleKey: 'mcsr-report',
    roles: ['FinanceManager', 'GeneralManager', 'OperationsManager', 'Admin', 'ProjectManager', 'ProjectCostControl', 'ProjectControlsDirector'],
    order: 38,
  },
  {
    key: 'mcsr-dashboard',
    path: '/mcsr/dashboard',
    label: 'MCSR Dashboard',
    icon: <McsrDashboardIcon />,
    component: McsrDashboard,
    moduleKey: 'mcsr-dashboard',
    roles: ['FinanceManager', 'GeneralManager', 'OperationsManager', 'Admin', 'ProjectControlsDirector'],
    order: 39,
  },
  {
    key: 'mcsr-sync',
    path: '/mcsr/sync',
    label: 'MCSR Sync Monitor',
    icon: <McsrSyncIcon />,
    component: McsrSyncMonitor,
    moduleKey: 'mcsr-sync',
    roles: ['FinanceManager', 'GeneralManager', 'OperationsManager', 'Admin', 'ProjectControlsDirector'],
    order: 39.5, // between mcsr-dashboard (39) and in-progress (40)
  },
  {
    key: 'project-reports',
    path: '/project-reports',
    label: 'Monthly Reports',
    icon: <ProjectReportsIcon />,
    component: ProjectReports,
    moduleKey: 'project-reports',
    roles: ['Admin', 'CEO', 'GeneralManager', 'OperationsManager', 'ProjectControlsDirector', 'PCDDirector', 'ProjectManager', 'ProjectCostControl'],
    order: 39.6,
  },
  {
    key: 'project-report-detail',
    path: '/project-reports/:id',
    label: 'Monthly Report',
    icon: <ProjectReportsIcon />,
    component: ProjectReportEditor,
    moduleKey: 'project-reports',
    order: 39.61,
    hideFromMenu: true,
  },
  {
    key: 'project-issues',
    path: '/project-issues',
    label: 'Project Issues',
    icon: <ProjectIssuesIcon />,
    component: ProjectIssues,
    moduleKey: 'project-issues',
    roles: ['Admin', 'CEO', 'GeneralManager', 'OperationsManager', 'ProjectControlsDirector', 'PCDDirector'],
    order: 39.7,
  },
  {
    key: 'petty-cash',
    path: '/petty-cash',
    label: 'Petty Cash Claims',
    icon: <PettyCashIcon />,
    component: PettyCashClaims,
    moduleKey: 'petty-cash',
    order: 39.8,
  },
  {
    key: 'petty-cash-new',
    path: '/petty-cash/new',
    label: 'New Petty Cash Claim',
    icon: <NewClaimIcon />,
    component: PettyCashClaim,
    moduleKey: 'petty-cash',
    order: 39.81,
  },
  {
    key: 'suppliers',
    path: '/suppliers',
    label: 'Suppliers',
    icon: <SuppliersIcon />,
    component: Suppliers,
    moduleKey: 'suppliers',
    order: 39.82,
  },
  {
    key: 'petty-cash-setup',
    path: '/petty-cash/setup',
    label: 'Petty Cash Setup',
    icon: <PettyCashSetupIcon />,
    component: PettyCashSetup,
    moduleKey: 'petty-cash-setup',
    order: 39.83,
  },
  {
    // No module: approvers and finance reviewers open the claims waiting for them from their e-mail, as with PRs.
    // The server decides who may see and act on each claim (services/pettyCash.service.ts).
    key: 'petty-cash-claim',
    path: '/petty-cash/:id',
    label: 'Petty Cash Claim',
    icon: <PettyCashIcon />,
    component: PettyCashClaim,
    moduleKey: '',
    order: 39.84,
    hideFromMenu: true,
  },
  // Enquiry to Invoice (backend /api/e2i): enquiry, estimate, quotation, job, client invoice request, register.
  {
    key: 'e2i-enquiries',
    path: '/e2i/enquiries',
    label: 'Enquiries',
    icon: <EnquiryIcon />,
    component: E2IEnquiries,
    moduleKey: 'e2i-enquiries',
    order: 39.9,
  },
  {
    key: 'e2i-invoice-requests',
    path: '/e2i/invoice-requests',
    label: 'Client Invoice Requests',
    icon: <InvoiceRequestIcon />,
    component: E2IInvoiceRequests,
    moduleKey: 'e2i-invoice-requests',
    order: 39.91,
  },
  {
    key: 'e2i-register',
    path: '/e2i/register',
    label: 'Quotation Register',
    icon: <QuotationRegisterIcon />,
    component: E2IRegister,
    moduleKey: 'e2i-register',
    order: 39.92,
  },
  {
    // Admin by default (an admin-only module key); anyone else through the module in User Management.
    key: 'e2i-setup',
    path: '/e2i/setup',
    label: 'Enquiry to Invoice Setup',
    icon: <E2ISetupIcon />,
    component: E2ISetup,
    moduleKey: 'e2i-setup',
    roles: ['Admin'],
    order: 39.93,
  },
  {
    // No module: approvers and finance open the enquiries waiting for them from their e-mail.
    // The server decides who may see and act on each enquiry.
    key: 'e2i-enquiry',
    path: '/e2i/enquiries/:id',
    label: 'Enquiry',
    icon: <EnquiryIcon />,
    component: E2IEnquiry,
    moduleKey: '',
    order: 39.94,
    hideFromMenu: true,
  },
];

export const getFirstAccessibleModulePath = (allowedModules: string[]): string | null => {
  const allowed = Array.isArray(allowedModules) ? allowedModules : [];
  const first = [...MODULES]
    .filter((item) => !item.hideFromMenu)
    .sort((a, b) => a.order - b.order)
    .find((item) => allowed.includes(item.moduleKey));
  return first?.path || null;
};

// Menu grouping for sidebar rendering (routes still come from MODULES)
export interface MenuGroup {
  key: string;
  label: string;
  icon?: React.ReactNode;
  children: ModuleItem[];
  order?: number;
}

// Define grouped menus as requested: group Inbox, In Progress, Completed; and Settings with Company/User/Schedule Jobs
export const MENU_GROUPS: MenuGroup[] = [
  {
    key: 'group-work',
    label: 'Work Flow',
    icon: <Inbox />,
    children: [
      MODULES.find((m) => m.label === 'Inbox'),
      MODULES.find((m) => m.label === 'In Progress'),
      MODULES.find((m) => m.label === 'Completed'),
    ].filter(Boolean) as ModuleItem[],
    order: 15,
  },
  {
    key: 'group-dashboard',
    label: 'Dashboard',
    icon: <DashboardIcon />,
    children: [
      MODULES.find((m) => m.key === 'dashboard'),
      MODULES.find((m) => m.key === 'pr-dashboard'),
    ].filter(Boolean) as ModuleItem[],
    order: 10,
  },
  {
    key: 'group-sales-portal',
    label: 'Sales Portal',
    icon: <StorefrontIcon />,
    children: [
      MODULES.find((m) => m.key === 'sales-stock'),
      MODULES.find((m) => m.key === 'sales-order-create'),
      MODULES.find((m) => m.key === 'sales-orders'),
      MODULES.find((m) => m.key === 'sales-soa'),
      MODULES.find((m) => m.key === 'formatted-soa'),
      MODULES.find((m) => m.key === 'formatted-soa-templates'),
      MODULES.find((m) => m.key === 'sales-approvals'),
      MODULES.find((m) => m.key === 'sales-order-report'),
      MODULES.find((m) => m.key === 'sales-invoice-print'),
      MODULES.find((m) => m.key === 'sales-order-print'),
      MODULES.find((m) => m.key === 'sales-portal-settings'),
    ].filter(Boolean) as ModuleItem[],
    order: 30,
  },
  {
    key: 'group-warehouse',
    label: 'Warehouse',
    icon: <WarehouseIcon />,
    children: [
      MODULES.find((m) => m.key === 'warehouse-receiving'),
      MODULES.find((m) => m.key === 'warehouse-barcode'),
      MODULES.find((m) => m.key === 'warehouse-picking-list'),
      MODULES.find((m) => m.key === 'warehouse-item-seed'),
      MODULES.find((m) => m.key === 'item-request-create'),
      MODULES.find((m) => m.key === 'item-requests'),
    ].filter(Boolean) as ModuleItem[],
    order: 32,
  },
  {
    key: 'group-mcsr',
    label: 'MCSR',
    icon: <Assessment />,
    children: [
      MODULES.find((m) => m.key === 'mcsr-report'),
      MODULES.find((m) => m.key === 'mcsr-dashboard'),
      MODULES.find((m) => m.key === 'mcsr-sync'),
    ].filter(Boolean) as ModuleItem[],
    order: 33,
  },
  {
    key: 'group-project-reports',
    label: 'Project Reports',
    icon: <ProjectReportsIcon />,
    children: [
      MODULES.find((m) => m.key === 'project-reports'),
      MODULES.find((m) => m.key === 'project-issues'),
    ].filter(Boolean) as ModuleItem[],
    order: 33.5,
  },
  {
    key: 'group-petty-cash',
    label: 'Petty Cash',
    icon: <PettyCashIcon />,
    children: [
      MODULES.find((m) => m.key === 'petty-cash'),
      MODULES.find((m) => m.key === 'petty-cash-new'),
      MODULES.find((m) => m.key === 'suppliers'),
      MODULES.find((m) => m.key === 'petty-cash-setup'),
    ].filter(Boolean) as ModuleItem[],
    order: 33.7,
  },
  {
    key: 'group-e2i',
    label: 'Enquiry to Invoice',
    icon: <EnquiryIcon />,
    children: [
      MODULES.find((m) => m.key === 'e2i-enquiries'),
      MODULES.find((m) => m.key === 'e2i-invoice-requests'),
      MODULES.find((m) => m.key === 'e2i-register'),
      MODULES.find((m) => m.key === 'e2i-setup'),
    ].filter(Boolean) as ModuleItem[],
    order: 33.8,
  },
  {
    key: 'group-subcontract',
    label: 'Subcontract',
    icon: <Gavel />,
    children: [
      MODULES.find((m) => m.key === 'create-subcontract'),
      MODULES.find((m) => m.key === 'subcontract-documents'),
      MODULES.find((m) => m.key === 'payment-certificate'),
      MODULES.find((m) => m.key === 'subcontract-variation'),
      MODULES.find((m) => m.key === 'subcontract-work-done'),
    ].filter(Boolean) as ModuleItem[],
    order: 26,
  },
  {
    key: 'group-settings',
    label: 'Settings',
    icon: <SettingsIcon />,
    children: [
      MODULES.find((m) => m.label === 'General Settings'),
      MODULES.find((m) => m.label === 'Company Management'),
      MODULES.find((m) => m.label === 'User Management'),
      MODULES.find((m) => m.label === 'Schedule Jobs'),
      MODULES.find((m) => m.label === 'Approval Flow'),
      MODULES.find((m) => m.label === 'SAP Approval Workflows'),
      MODULES.find((m) => m.label === 'Accounts notifications'),
      MODULES.find((m) => m.label === 'Payment Request Workflow'),
      MODULES.find((m) => m.label === 'Bulk Workflow Management'),
      MODULES.find((m) => m.label === 'Project Management'),
      MODULES.find((m) => m.label === 'Role Management'),
      MODULES.find((m) => m.label === 'Cost Center Mapping'),
      MODULES.find((m) => m.label === 'Transaction Sync'),
      MODULES.find((m) => m.label === 'System Monitor'),
      MODULES.find((m) => m.label === 'G/L Rules Year Copy'),
    ].filter(Boolean) as ModuleItem[],
    order: 80,
  },
];

export default MODULES;
